/**
 * Script para cambiar color de botones Semantic según su texto
 */

export function applyButtonColors() {
  // Seleccionar tanto buttons como enlaces <a> con clase global_Bordered
  const buttons = document.querySelectorAll('button[class*="global_Bordered"], a[class*="global_Bordered"]');

  buttons.forEach((button) => {
    const text = (button.innerText || button.textContent || '').trim().toLowerCase();
    let bgColor, shadowColor;
    
    if (text.includes('guardar')) {
      bgColor = '#3b82f6';
      shadowColor = 'rgba(59, 130, 246, 0.35)';
    } else if (text.includes('cancelar')) {
      bgColor = '#ef4444';
      shadowColor = 'rgba(239, 68, 68, 0.35)';
    } else {
      bgColor = '#06b6d4';
      shadowColor = 'rgba(6, 182, 212, 0.35)';
    }
    
    // Usar setAttribute para que !important funcione y aplicar todos los estilos necesarios
    const styleStr = `
      background: ${bgColor} !important;
      box-shadow: 0 4px 14px ${shadowColor} !important;
      color: white !important;
      border: none !important;
      border-radius: 7px !important;
      padding: 4px 12px !important;
      min-height: 28px !important;
      height: auto !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 6px !important;
      cursor: pointer !important;
      transition: background-color var(--theme-transition-background-duration, 200ms) var(--theme-transition-easing, ease),
        color var(--theme-transition-color-duration, 200ms) var(--theme-transition-easing, ease),
        border-color var(--theme-transition-border-duration, 200ms) var(--theme-transition-easing, ease),
        box-shadow 200ms ease, transform 200ms ease, filter 200ms ease !important;
    `;
    
    // Evita invalidar estilos y repintar botones cuando nada cambió.
    if (button.getAttribute('style') !== styleStr) {
      button.setAttribute('style', styleStr);
    }
  });
}

// Ejecutar al cargar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(applyButtonColors, 100);
  });
} else {
  applyButtonColors();
}

// Observer para cuando cambien los botones
const observer = new MutationObserver(() => {
  applyButtonColors();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Ejecutar cada 200ms
setInterval(applyButtonColors, 200);

